/// <amd-module name="Build/Common/Library/Contracts" />
import { IVssService } from "VSS/Platform/Context";

export interface ILanguageEditorService extends IVssService {
    /**
     * Initialize this monaco editor with YAML capabilities.
     */
    initializeEditor(editor: monaco.editor.IStandaloneCodeEditor, options?: CodeLensOptions): void;

    /**
     * Replaces the YAML schema with the provided one. If none is provided, it will use /yamlschema REST API.
     * @param schema It's a JSONSchema, but we don't want to add a dependency to AzurePipelinesLanguageService here.
     */
    useSchema(schema: any): void;
}

export interface CodeLensOptions {
    onEditTask?: () => void;
    onOpenTemplate?: (template: string) => void;
    onValidate?: () => void;
    checkTemplate?: (template: string) => boolean | undefined;
}